import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchDropdown({
  isLoading,
  onSelectResult,
  options = [],
  showSuggestions,
  use
}) {
  if (!showSuggestions) {
    return null;
  }
  if (isLoading) {
    return /*#__PURE__*/_jsx(List, {
      "data-test-id": "loading-suggestions",
      children: /*#__PURE__*/_jsx(ListItem, {
        children: "Loading..."
      })
    });
  }
  if (options.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: use === 'on-dark' ? 'fill-surface-default' : 'fill-field-default',
    borderRadius: "200",
    boxShadow: "400",
    insetInlineEnd: '0',
    insetInlineStart: '0',
    listStyleType: "none",
    marginBlockStart: "100",
    maxBlockSize: "300px",
    overflowY: "auto",
    padding: "250",
    position: "absolute",
    children: /*#__PURE__*/_jsx(List, {
      "data-test-id": "search-results-list",
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "300",
        children: options.map((result, index) => /*#__PURE__*/_jsx(ListItem, {
          children: typeof result === 'string' ? /*#__PURE__*/_jsx(Button, {
            use: "unstyled",
            onClick: () => onSelectResult(result),
            children: result
          }) : /*#__PURE__*/_jsx("div", {
            children: result
          })
        }, index))
      })
    })
  });
}